import { baseApiAddresses } from './urls';
import { getToken } from './token';

export function hostReachable() {
  // Handle IE and more capable browsers
  const xhr = new (window.ActiveXObject || XMLHttpRequest)('Microsoft.XMLHTTP');

  // Open new request as a HEAD to the root hostname with a random param to bust the cache
  xhr.open('HEAD', `${window.location.origin}/?rand=${Math.floor((1 + Math.random()) * 0x10000)}`, false);

  // Issue request and handle response
  try {
    xhr.send();
    return (xhr.status >= 200 && (xhr.status < 300 || xhr.status === 304 || xhr.status === 404));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return false;
  }
}

// the check sends no token - keepAlive answered it with 401 on every failed request; the version needs no login
function reachabilityUrl() {
  const base = baseApiAddresses[process.env.HOTELMEISTER_ENV];
  return /ui\/backend\/?$/.test(base) ? base.replace(/ui\/backend\/?$/, 'status/version') : `${base}echo/keepAlive`;
}

export function apiReachable() {
  // Handle IE and more capable browsers
  const xhr = new (window.ActiveXObject || XMLHttpRequest)('Microsoft.XMLHTTP');

  // Open new request as a HEAD to a public endpoint with a random param to bust the cache
  xhr.open('HEAD', `${reachabilityUrl()}?rand=${Math.floor((1 + Math.random()) * 0x10000)}`, false);

  // Issue request and handle response
  try {
    xhr.send();
    return (xhr.status >= 200 && (xhr.status < 300 || xhr.status === 304 || xhr.status === 401));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return false;
  }
}

let offlineUpdater = null;
let offlineConfirmation = null;
let confirmingOffline = false;

const OFFLINE_CONFIRMATION_DELAY = 3 * 1000;

export function updateOfflineStatus() {
  const offline = !navigator.onLine || !hostReachable() || !apiReachable();

  // a single failed check (e.g. requests a CDN turns away during a hard reload) is not shown yet, only when the
  // check a few seconds later still fails - unless the browser itself reports that there is no connection
  if (offline && !window.hmOffline && navigator.onLine && !confirmingOffline) {
    if (offlineConfirmation === null) {
      offlineConfirmation = setTimeout(() => {
        offlineConfirmation = null;
        confirmingOffline = true;
        try {
          updateOfflineStatus();
        } finally {
          confirmingOffline = false;
        }
      }, OFFLINE_CONFIRMATION_DELAY);
    }
    return;
  }

  if (!offline && offlineConfirmation !== null) {
    clearTimeout(offlineConfirmation);
    offlineConfirmation = null;
  }

  window.hmOffline = offline;

  if (window.hmOffline && offlineUpdater === null) {
    offlineUpdater = setInterval(updateOfflineStatus, 15 * 1000);
    if (typeof window.onHmOffline === 'function') {
      window.onHmOffline();
    }
  } else if (!window.hmOffline) {
    clearInterval(offlineUpdater);
    offlineUpdater = null;
    if (typeof window.onHmOnline === 'function') {
      window.onHmOnline();
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/util/offline.js